/** Types */
interface BundlePriceProps {
  price: number;
  upgradePrice?: number;
  discountedCredits?: number;
}

/**
 * @description Item price component for job activation packages. Account for price difference on upgrade.
 * - `price`: The price.
 * - `upgradePrice`: The upgrade price.
 */
export const ItemPrice = (props: BundlePriceProps) => {
  // Destructure props


  const { price, upgradePrice, discountedCredits } = props;

  const isDiscounted = price !== discountedCredits;

  // Render component
  // *************************
  return (
    <>
      {isDiscounted && (
        <div className="relative flex items-center gap-1">
          <span className="ml-1 block text-sm font-thin text-error line-through">{price}</span>
          <span>{discountedCredits}</span>
        </div>
      )}

      {!isDiscounted && upgradePrice !== undefined && price !== upgradePrice && (
        <div className="relative flex items-center gap-1">
          <span className="ml-1 block text-sm font-thin text-error line-through">{price}</span>
          <span>{upgradePrice}</span>
        </div>
      )}

      {!isDiscounted && (upgradePrice === undefined || price === upgradePrice) && (
      <span>{price}</span>
      )}
    </>
  );
};
